import { render, staticRenderFns } from "./NodesCosts.vue?vue&type=template&id=1fa56e5b&scoped=true"
import script from "./NodesCosts.vue?vue&type=script&lang=js"
export * from "./NodesCosts.vue?vue&type=script&lang=js"
import style0 from "./NodesCosts.vue?vue&type=style&index=0&id=1fa56e5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa56e5b",
  null
  
)

export default component.exports